export const adaptIpAddresses = (ipAddresses) => {
  const IPs = Object.keys(ipAddresses || {})?.map((ipKey) => {
    return {
      ip: ipKey || '-',
      type: ipAddresses?.[ipKey]?.['tag']?.replaceAll('_', ' ') || '-',
    };
  });
  return IPs || [];
};
